<!-- 
 * @description: 账号登录模块
 * @fileName: template.vue 
 * @author: 薛微微 
 * @date: 2023-06-21 17:05:28
!-->
<template>
  <div :class="this.$Base.checkSysteam() == 'MOBILE' ? 'mlogin' : 'login'">
    <!-- input -->
    <div class="inputBox">
      <div class="input-style">
        <input
          type="text"
          :placeholder="$t('message.input_account')"
          class="user"
          v-model.trim="username"
          @click="focusEnd('username')"
          id="username"
        />
      </div>
      <div class="input-style">
        <input
          type="password"
          :placeholder="$t('message.input_password')"
          class="pass"
          v-model.trim="password"
          @click="focusEnd('password')"
          id="password"
        />
      </div>
      <div class="input-style" v-if="isCodeShow">
        <input
          type="text"
          :placeholder="$t('message.enter_code')"
          class="code"
          v-model.trim="code"
          @click="focusEnd('code')"
          id="code"
        />
        <div class="random" @click="getImage">
          <img :src="imgC" />
        </div>
      </div>
    </div>
    <!-- 登陆按钮 -->
    <div
      class="sendBtn"
      :class="
        username && password && (isCodeShow == false || (isCodeShow && code))
          ? 'active'
          : ''
      "
      @click="login()"
    >
      {{ $t("message.navigator_lang") }}
    </div>
    <!-- 找回密码按钮 -->
    <div class="forgotPass">
      <span @click="childForgot">{{ $t("message.retrieve_password") }}</span>
    </div>
    <!-- or 横线 -->
    <div class="Or"></div>
    <!-- 第三方登陆 -->
    <ul
      class="thirdPart"
      :class="
        (this.$Base.checkSysteam() == 'MOBILE' ? 'mlogin' : 'login', classLang)
      "
      v-if="system === 'PC'"
    >
      <li
        v-if="loginType.fb"
        class="facebook"
        @click="webDotChildLogin('click_pcldy_facebook')"
      >
        <img src="./../../assets/icon_fb.png" alt="" class="i-icon" />
        <span class="i-text">Facebook</span>
        <fb-signin-button
          class="facebookLogin"
          :params="fbSignInParams"
          @success="FacebookonSuccess"
          @error="FacebookonFailure"
        ></fb-signin-button>
      </li>
      <li v-if="loginType.gl">
        <img src="./../../assets/icon_google.png" alt="" class="i-icon" />
        <span class="i-text">Google</span>
        <div
          class="g_id_signin GoogleLogin"
          id="g_id_signin"
          @click="webDotChildLogin('click_pcldy_google')"
        ></div>
      </li>
      <li v-if="loginType.phone" class="MobileLogin" @click="childPhone">
        <img src="./../../assets/icon_phone.png" alt="" class="i-icon" />
        <span class="i-text">{{ $t("message.navigator_mobile_logout") }}</span>
      </li>
      <li v-if="loginType.mail" class="Email" @click="childMailbox">
        <img src="./../../assets/icon_email.png" alt="" class="i-icon" />
        <span class="i-text">{{ $t("message.navigator_email_logout") }}</span>
      </li>
    </ul>

    <ul class="thirdPart" :class="classLang" v-if="system === 'MOBILE'">
      <li
        v-if="loginType.fb"
        class="facebook"
        @click="webDotChildLogin('click_moldy_facebook')"
      >
        <img src="./../../assets/icon_fb.png" alt="" class="i-icon" />
        <span class="i-text">Facebook</span>
        <fb-signin-button
          class="facebookLogin"
          :params="fbSignInParams"
          @success="FacebookonSuccess"
          @error="FacebookonFailure"
        ></fb-signin-button>
      </li>
      <li v-if="loginType.gl">
        <img src="./../../assets/icon_google.png" alt="" class="i-icon" />
        <span class="i-text">Google</span>
        <div
          class="g_id_signin GoogleLogin"
          id="g_id_signin"
          @click="webDotChildLogin('click_pcldy_google')"
        ></div>
      </li>
      <li v-if="loginType.phone" class="MobileLogin" @click="childPhone">
        <img src="./../../assets/icon_phone.png" alt="" class="i-icon" />
        <span class="i-text">{{ $t("message.navigator_mobile_logout") }}</span>
      </li>
      <li v-if="loginType.mail" class="Email" @click="childMailbox">
        <img src="./../../assets/icon_email.png" alt="" class="i-icon" />
        <span class="i-text">{{ $t("message.navigator_email_logout") }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from "vue";
import FBSignInButton from "vue-facebook-signin-button";
Vue.use(FBSignInButton);
import { RSSign } from "../../utils/sign.js";

export default {
  name: "RastarLogin",
  props: [
    "appId",
    "pId",
    "mdId",
    "ukey",
    "isForgot",
    "isMailbox",
    "isPhone",
    "someprops",
    "initialization",
    "system",
    "getCodeShow",
  ],
  components: {},
  data() {
    return {
      isaa: false,
      isA: false,
      //账号
      username: "",
      // 密码
      password: "",
      // 二维码
      code: "",
      imgC: "",
      isCodeShow: false,
      token: "",
      captchaCode: "",
      // GoogleParams: {
      //   client_id:
      //     "864612029967-lg671faj52nat87vh7d6tscsashcfcbr.apps.googleusercontent.com",
      //   scope: "email",
      // },
      fbSignInParams: {
        scope: "email,user_likes",
        return_scopes: true,
      },
      emailBindShow: 0,
      apiUrl: JSON.parse(this.$Storage.localStorageGet("api")),
      classLang: "",
      loginType: {
        fb: true,
        gl: true,
        phone: true,
        mail: true,
      },
    };
  },
  computed: {
    GoogleParams: function () {
      let client_id =
        "864612029967-lg671faj52nat87vh7d6tscsashcfcbr.apps.googleusercontent.com";
      if (this.appId == "103321") {
        client_id =
          "759807831783-g7ri4jm7deir5al9h0i0fcjfcqq92nni.apps.googleusercontent.com";
      } else if (this.appId == "104293") {
        client_id =
          "78655690810-bttulpd6i6jrf6eqj8p6h6v3hqr44n2d.apps.googleusercontent.com";
      }
      return {
        client_id,
        scope: "email",
      };
    },
  },
  watch: {
    initialization: {
      handler(val, oldV) {
        console.log("initialization===", val, oldV);
        if (val) {
          this.getImage();
        }
      },
      deep: true,
    },
  },
  methods: {
    sendCodeShow() {
      this.getCodeShow(this.isCodeShow);
    },
    classIdentification() {
      let langVal = this.$Storage.localStorageGet("lang");
      if (langVal.substring(0, 2) == "zh") {
        this.classLang = "widZhong";
      } else if (langVal.substring(0, 2) == "th") {
        this.classLang = "widTai";
      } else {
        this.classLang = "widYing";
      }
    },
    focusEnd(id) {
      let inpEl = document.getElementById(id);
      inpEl.focus();
      let length = inpEl.value.length;
      if (document.selection) {
        let range = inpEl.createTextRange();
        range.moveStart("character", length);
        range.collapse();
        range.select();
      } else if (
        typeof inpEl.selectionStart === "number" &&
        typeof inpEl.selectionEnd === "number"
      ) {
        // selectionStart和selectionEnd两个属性是当前选中文本起始位置的索引
        inpEl.selectionStart = inpEl.selectionEnd = length;
      }
    },
    /*
     *@description: 触发埋点上报
     *@author: 薛微微
     *@date: 2023-06-21 17:06:16
     */
    webDotChildLogin(nodeVal) {
      this.$Report.webDotFather(this.pId, this.appId, this.ukey, nodeVal);
    },
    /*
     *@description: 接口错误上报
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    webErrorlogChild(errorMsg, action) {
      this.$Report.webErrorlogFather(
        this.pId,
        this.appId,
        this.ukey,
        errorMsg,
        action
      );
    },
    /*
     *@description: 找回密码
     *@author: 薛微微
     *@date: 2023-06-21 17:07:03
     */
    childForgot() {
      if (this.system === "PC") {
        this.webDotChildLogin("click_pcldy_forget");
      } else {
        this.webDotChildLogin("click_moldy_forget");
      }
      this.$emit("forgot", true);
    },
    childMailbox() {
      this.$emit("mailbox", true);
    },
    childPhone() {
      this.$emit("phoneB", true);
    },
    /*
     *@description: 获取图形验证码
     *@author: 薛微微
     *@date: 2023-06-21 17:07:33
     */
    getImage() {
      let _this = this;
      this.$generalMethod.captcha(this.pId, this.appId, "login").then((res) => {
        if (res.code == 200) {
          let data = res.data;
          _this.isCodeShow = data.flag == 1 ? true : false;
          _this.imgC = res.data.captcha;
          _this.captchaCode = data.captcha_code;
          _this.sendCodeShow();
        } else {
          _this.$toast(res.msg.replace(/\[.*?\]/g, ""));
        }
      });
    },
    /*
     *@description: 登录前置判断
     *@author: 薛微微
     *@date: 2023-06-21 17:08:53
     */
    login() {
      let _this = this;
      if (
        !(
          _this.username &&
          _this.password &&
          (_this.isCodeShow == false || (_this.isCodeShow && _this.code))
        )
      )
        return;
      if (this.system === "PC") {
        _this.webDotChildLogin("click_pcldy_password_login");
      } else {
        _this.webDotChildLogin("click_moldy_password_login");
      }
      var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
      if (reg.test(_this.password)) {
        _this.$toast(_this.$t("message.emailTips1"));
        return;
      }
      //Email正则
      // var ePattern =/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/;
      // 验证码是否一致
      if (_this.isCodeShow == 1) {
        if (_this.captchaCode.toLowerCase() != _this.code.toLowerCase()) {
          _this.$toast(_this.$t("message.emailTips4"));
          return;
        }
      }
      let isCache = this.$Storage.localStorageGet("deviceIdUa");
      if (!isCache) {
        // 不存在就强制刷新页面 deviceIdUa isCache不存在
        location.reload();
      } else {
        // deviceIdUa 存在
        this.$generalMethod
          .freezetoken(this.pId, this.appId, this.mdId)
          .then((res) => {
            if (res.code == 200) {
              let uinfoData = {
                uname: _this.username,
                pwd: _this.password,
              };
              _this.loginSubmit(res.data, "Account", uinfoData);
            }
          });
      }
    },
    /*
     *@description: 请求登录接口
     *@author: 薛微微
     *@date: 2023-06-21 17:10:00
     */
    loginSubmit(token, ltype, uinfoData) {
      let _this = this;
      let data = {
        ts: new Date().getTime(),
        cch_id: _this.pId,
        app_id: _this.appId,
        md_id: _this.mdId,
        sys_language: this.$Storage.localStorageGet("lang"),
        token: token,
        ltype: ltype,
        time_zone: this.$Base.timeZone(),
        nonce: this.$Base.nonce(12),
        sdk_ver: this.$Base.sdkVer(),
        version: this.$Base.getVersion(),
      };
      data.device_id = this.$Storage.localStorageGet("deviceIdUa");
      data.uinfo = this.$Ciphertext.AESkey(uinfoData);

      data.sign = RSSign(data, data.app_id);
      this.$SyModel
        .login(this.apiUrl.user.normal_login, data)
        .then((res) => {
          if (res.code == 200) {
            _this.$emit("loginSuccess", res);
            // _this.emailBindShow = res.data.email_bind_show;
            // this.$Storage.localStorageSet("show", _this.emailBindShow);
            this.$Storage.localStorageSet("apiUname", _this.username);
            this.$Storage.localStorageSet("apiPwd", _this.password);
            // this.$Storage.localStorageSet("_XH_U_WEBSDK", res.data.uinfo);
            // this.$Storage.localStorageSet("serviceUinfo", res.data.kf_uinfo);
            // this.$Storage.localStorageSet(
            //   "access_token",
            //   res.data.access_token
            // );
            // // 登陆成功埋点
            // if (this.system === "PC") {
            //   _this.webDotChildLogin("login_pcldy_password_success");
            // } else {
            //   _this.webDotChildLogin("login_moldy_password_success");
            // }
            // // 登陆成功了跳转页面
            // window.location.href = `/web?ukey=${_this.ukey}&appid=${_this.appId}&pid=${_this.pId}&md_id=${_this.mdId}`;
          } else {
            let errorMsg = res.msg.replace(/\[.*?\]/g, "");
            _this.$toast(errorMsg);
            _this.getImage();
          }
        })
        .catch((err) => {
          this.$toast(err.replace(/\[.*?\]/g, ""));
          this.webErrorlogChild(err.msg, "账号login接口");
        });
    },
    /*
     *@description: FB登录 https://blog.csdn.net/qq_42386231/article/details/120063148?utm_medium=distribute.pc_relevant.none-task-blog-2~default~baidujs_title~default-1.highlightwordscore&spm=1001.2101.3001.4242.2
     *@author: 薛微微
     *@date: 2023-06-21 17:10:40
     */
    FacebookonSuccess(response) {
      console.log("facebook response===", response);
      let _this = this;
      // 登录成功回调
      _this.$generalMethod
        .freezetoken(this.pId, this.appId, this.mdId)
        .then((res) => {
          if (res.code == 200) {
            var uesr = response.authResponse.accessToken;
            let uinfoData = {
              bind_v: uesr,
              bind_type: 3,
            };
            if (response.status == "connected") {
              _this.loginSubmit(res.data, "Facebook", uinfoData);
            }
          }
        });
    },
    FacebookonFailure(error) {
      console.log("FacebookonFailure====", error);
    },
    /*
     *@description: 谷歌登录 https://developers.google.cn/identity/gsi/web/reference/js-reference?hl=zh-cn 或者 https://blog.csdn.net/weixin_43458965/article/details/125484887
     *@author: 薛微微
     *@date: 2023-06-21 17:10:24
     */
    handleCredentialResponse(response) {
      console.log("Encoded JWT ID token: " + response.credential);
      this.$generalMethod
        .freezetoken(this.pId, this.appId, this.mdId)
        .then((res) => {
          if (res.code == 200) {
            let uinfoData = {
              bind_v: response.credential,
              bind_type: 2,
            };
            this.loginSubmit(res.data, "Googleplay", uinfoData);
          }
        });
    },
    /**
     * 根据游戏控制显示登录方式
     */
    showLoginType() {
      // 越南登录隐藏手机登录 appid 104293
      if (this.appId == "104293") {
        this.loginType.phone = false;
      }
    },
  },
  created() {
    this.getImage();
    this.showLoginType();
  },
  mounted() {
    this.classIdentification();
    /*
     *@description: 谷歌登录按钮样式初始化
     *@author: 薛微微
     *@date: 2023-06-21 17:10:24
     */
    window.addEventListener("click", () => {
      window.google.accounts.id.initialize({
        // 主要就是填写client_id
        client_id: this.GoogleParams.client_id,
        auto_select: false,
        callback: this.handleCredentialResponse,
      });
      // 设置按钮的样式等
      window.google.accounts.id.renderButton(
        document.getElementById("g_id_signin"),
        {
          type: "standard",
          theme: "outline",
          size: "medium",
          text: "signin",
          shape: "pill",
          logo_alignment: "left",
          locale: this.$Storage.localStorageGet("lang"),
        }
      );
      // window.google.accounts.id.prompt(); // 也显示一次点击对话框
    });
  },
};
</script>

<style lang="scss" src="./style.scss" scoped></style>
